import React from 'react';
import LinkButton from '@shared/components/LinkButton';
import { useReactiveVar } from '@apollo/client';
import { userInfo } from '@apollo-internal/cache';
import PrivilegeNames from '../../../../../constants/privilegeNames';

const AddEventLinkButton = () => {
  const currentUserInfo = useReactiveVar(userInfo);

  if (!currentUserInfo.Privileges.includes(PrivilegeNames.Calendar_AddEvent)) {
    return null;
  }

  return (
    <LinkButton className='primary-button sm' to='/calendar/add-event'>
      Add Event
    </LinkButton>
  );
};

export default AddEventLinkButton;
